import { render, staticRenderFns } from "./details_view.vue?vue&type=template&id=2fe1d0f1&"
import script from "./details_view.vue?vue&type=script&lang=ts&"
export * from "./details_view.vue?vue&type=script&lang=ts&"
import style0 from "./details_view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports